import { render, staticRenderFns } from "./MobileNumberForm.vue?vue&type=template&id=06ffb18a"
import script from "./MobileNumberForm.vue?vue&type=script&lang=js"
export * from "./MobileNumberForm.vue?vue&type=script&lang=js"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports